import React from 'react';

function EditLargeSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4352 3.00009C18.6542 2.21904 17.3878 2.21904 16.6068 3.00009L8.83711 10.7698C8.65083 10.956 8.50319 11.1773 8.40267 11.4208L7.4083 13.8294C6.72922 15.4742 8.37526 17.1203 10.0202 16.4412L12.4287 15.4468C12.6722 15.3463 12.8935 15.1987 13.0797 15.0124L20.8494 7.24273C21.6305 6.46169 21.6305 5.19535 20.8494 4.41431L19.4352 3.00009ZM18.021 4.41431L19.4352 5.82852L18.021 7.24273L16.6068 5.82852L18.021 4.41431ZM15.1926 7.24273L16.6068 8.65695L11.6655 13.5982L9.25695 14.5926L10.2513 12.184L15.1926 7.24273Z"
      />
      <path d="M5 3.99994C3.34315 3.99994 2 5.34309 2 6.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H17C18.6569 21.9999 20 20.6568 20 18.9999V14.9999C20 14.4477 19.5523 13.9999 19 13.9999C18.4477 13.9999 18 14.4477 18 14.9999V18.9999C18 19.5522 17.5523 19.9999 17 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V6.99994C4 6.44766 4.44772 5.99994 5 5.99994H9C9.55228 5.99994 10 5.55223 10 4.99994C10 4.44766 9.55228 3.99994 9 3.99994H5Z" />
    </svg>
  );
}

export default EditLargeSVG;
